/* eslint-disable */
// tslint:disable
/**
 * Isletnet API
 *  # Islets  Rest API for [IsletNet](http://isletnet.com/) - an accurate neural network based tool for automated segmentation and analysis  of pancreatic (Langerhans) islets. For more information, see the IsletNet [User guide](http://isletnet.com/guide) or try the tool at  [www.isletnet.com](http://isletnet.com/).  Both IsletNet and this API serve for two main usecases:  ## Analysis   The main usecase.   User submits a request:   - images of the tissue AND/OR own segmentations (can be mixed) - user input data (information about batch of images)   The API returns the response containing: - automated segmentation of islets for each submitted image of the tissue  - histogram of islet size distribution for each image - results of the analysis (both detailed results per image and overall summary)  ## Validation  The usecase to assess the accuracy of one\'s own segmentation by submitting both the segmentation and the  original image. The API returns the comparison of his segmentation to the automated one, returning both  visual and statistical summary.  User submits a request:  - image&own_segmentation (mask) pairs  The API returns the response containing: - results of validation against the automated segmentation - visual comparison 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchMetadata
 */
export interface BatchMetadata {
    /**
     * 
     * @type {string}
     * @memberof BatchMetadata
     */
    batchId: string;
    /**
     * 
     * @type {string}
     * @memberof BatchMetadata
     */
    camera?: string;
    /**
     * 
     * @type {number}
     * @memberof BatchMetadata
     */
    dilution?: number;
    /**
     * 
     * @type {string}
     * @memberof BatchMetadata
     */
    microscope?: string;
    /**
     * 
     * @type {number}
     * @memberof BatchMetadata
     */
    objective?: number;
    /**
     * 
     * @type {string}
     * @memberof BatchMetadata
     */
    operator: string;
    /**
     * 
     * @type {number}
     * @memberof BatchMetadata
     */
    pelletVolumeMl?: number;
    /**
     * 
     * @type {string}
     * @memberof BatchMetadata
     */
    sessionCode: string;
}

export function BatchMetadataFromJSON(json: any): BatchMetadata {
    return BatchMetadataFromJSONTyped(json, false);
}

export function BatchMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'batchId': json['batch_id'],
        'camera': !exists(json, 'camera') ? undefined : json['camera'],
        'dilution': !exists(json, 'dilution') ? undefined : json['dilution'],
        'microscope': !exists(json, 'microscope') ? undefined : json['microscope'],
        'objective': !exists(json, 'objective') ? undefined : json['objective'],
        'operator': json['operator'],
        'pelletVolumeMl': !exists(json, 'pellet_volume_ml') ? undefined : json['pellet_volume_ml'],
        'sessionCode': json['session_code'],
    };
}

export function BatchMetadataToJSON(value?: BatchMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'batch_id': value.batchId,
        'camera': value.camera,
        'dilution': value.dilution,
        'microscope': value.microscope,
        'objective': value.objective,
        'operator': value.operator,
        'pellet_volume_ml': value.pelletVolumeMl,
        'session_code': value.sessionCode,
    };
}


